import { breakpoints } from '@bnnvara/breakpoints';
import { globalBorderRadius } from '@bnnvara/themes';
import styled from 'styled-components';
export const Container = styled.div`
  display: grid;
  grid-template-columns: 112px auto;
  background-color: ${({
  theme
}) => theme.base.white};
  border-radius: ${globalBorderRadius};

  ${breakpoints.md} {
    display: flex;
    flex-direction: column;
    border: 1px solid ${({
  theme
}) => theme.tertiary.main};
  }
`;
export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 96px;
  flex-shrink: 0;
  margin-right: 8px;

  ${breakpoints.md} {
    margin-right: 0;
    padding-bottom: 56.2%;
    width: 100%;
    height: auto;
    border-radius: ${globalBorderRadius};
  }
`;
export const Image = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: ${globalBorderRadius} 0 0 ${globalBorderRadius};

  ${breakpoints.md} {
    border-radius: ${globalBorderRadius} ${globalBorderRadius} 0 0;
  }
`;
export const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding-left: 8px;
  color: ${({
  theme
}) => theme.base.black};

  ${breakpoints.md} {
    justify-content: space-between;
    padding: 16px 20px 25px 20px;
    height: 206px;
  }
`;